var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-related-items"},[_c('p',{staticClass:"item-related-items__title text--bold text--size-14"},[_vm._v("비슷한 아이템 추천 🍕")]),_c('div',{staticClass:"item-related-items__items"},_vm._l((_vm.items),function(item){return _c('ItemTile',{key:item.id,attrs:{"item":Object.assign({}, item,
        {imageSrc: item.medias[0].path,
        brandName: _vm.brandName(item)})}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }